<template>
<v-row class="im-result regular" no-gutters align="center">
    <v-col cols="2" md="1" class="px-1">
        <v-avatar class="elevation-4" size="36" :style="{background: item.color}" />
    </v-col>
    <v-col cols="5" md="3" class="px-2">
        <div>{{ item.slug}}</div>

    </v-col>
    <v-col cols="5" md="3" class="px-2">
        <div>{{ item.name}}</div>
    </v-col>
    <v-col cols="12" md="5" class="px-2">
        <div>{{ item.description }}</div>
    </v-col>
</v-row>
</template>

<script>
import defaults from "../../utils/PropDefaults.js"

export default {
    props: {
        item: {
            type: Object,
            default: defaults.service_item
        },
    },
    methods: {
        emitClick() {
            this.$emit('click');
        },
    }
}
</script>
